// Utilidades para agrupar productos por talla dentro de una categoría.
// Cada talla exacta es su propio grupo (34B y 34C van aparte).

export const normalizarTalla = (t) => (t || '').trim().toUpperCase();

// Orden de tallas de ropa por letra (para que S vaya antes que M, etc.)
const ORDEN_ROPA = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, XXXL: 7 };

// Clave de ordenamiento: ropa por letra, luego numéricas (con copa), luego el resto.
const claveOrden = (talla) => {
  const t = normalizarTalla(talla);
  if (ORDEN_ROPA[t] !== undefined) return [0, ORDEN_ROPA[t], ''];
  const m = t.match(/^(\d+)\s*(.*)$/); // "34B" -> 34 + "B"
  if (m) return [1, parseInt(m[1], 10), m[2]];
  return [2, 0, t];
};

export const compararTallas = (a, b) => {
  const [ga, na, ra] = claveOrden(a);
  const [gb, nb, rb] = claveOrden(b);
  if (ga !== gb) return ga - gb;
  if (na !== nb) return na - nb;
  return ra.localeCompare(rb);
};

// Devuelve las tallas distintas (ordenadas) de una lista de productos,
// y si hay productos sin talla.
export function tallasDeProductos(productos) {
  const set = new Set();
  let haySinTalla = false;
  productos.forEach((p) => {
    const t = normalizarTalla(p.talla);
    if (t) set.add(t);
    else haySinTalla = true;
  });
  return { tallas: [...set].sort(compararTallas), haySinTalla };
}

// ¿La categoría usa tallas? (al menos un producto con talla)
export const categoriaUsaTallas = (productos, categoria) =>
  productos.some((p) => p.categoria === categoria && normalizarTalla(p.talla));
